export const Grain = () => {
  return <div className="grain-overlay" aria-hidden="true" data-testid="grain-overlay" />;
};

export default Grain;
